import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { syncConfirmedConversions } from 'Utils/ConversionTracking';

/**
 * Keep the signed-in account's confirmed conversions in step with the backend:
 * on load and on every route change, and on the web also every minute and when
 * the window regains focus. The native apps only send the account's
 * attribution, so there is nothing for them to poll for.
 */
export const useConfirmedConversionSync = (
  userId: string | undefined,
  isAuthenticated: boolean,
  getToken: () => Promise<string | undefined>,
  pathname: string,
): void => {
  useEffect(() => {
    if (!isAuthenticated || !userId) return;
    const sync = () => void syncConfirmedConversions(userId, getToken);
    sync();
    if (Capacitor.isNativePlatform()) return;
    const timer = window.setInterval(sync, 60_000);
    window.addEventListener('focus', sync);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', sync);
    };
  }, [isAuthenticated, getToken, userId, pathname]);
};
